<template>
  <gj-table
      ref="gjTable"
      adaptParent
      :index="false"
      :loading="loading"
      :data="tableData"
      :columns="columns"
      :offset-height="40"
      :show-overflow="false"
      :pagination="pagination"
      @page-change="$gjQuery">
    <!--            名称-->
    <template v-slot:logName="{ row }">
      <div style="color: #999">{{ row.objectType | optionsText(options.objectType) }}</div>
      <gj-tooltip :content="row.objectName">
        <div>{{ row.objectName }}</div>
      </gj-tooltip>
    </template>
    <!--            调整类型-->
    <template v-slot:objectType="{ row }">
      <div>{{ row.operatingType | optionsText(options.optOptions) }}{{ row.content }}</div>
    </template>
    <!--            操作结果-->
    <template v-slot:result="{ row }">
      <div>
        {{ row.result | optionsText(options.resultOptions) }}
        <gj-tooltip v-if="row.detail" :content="row.detail">
          <i class="el-icon-arrow-down"></i>
        </gj-tooltip>
      </div>
    </template>

  </gj-table>
</template>

<script>
import {AdLog} from "@/views/modules/ad/common/enum";
import {Log} from "@/api/ad";
import {queryMixin} from "@/minxins";

export default {
  name: "manual-table",
  mixins: [queryMixin],
  filters: {
    optionsText(val, options) {
      const item = options.find(e => e.id == val);
      return item ? item.text : val
    },
  },
  props:{
    model:{
      type: Object,
      default:()=>{}
    }
  },
  data(){
    return {
      tableData: [],
      columns: [
        {id: 'createLocationDate', header: '操作时间（站点时间）', field: 'createLocationDate', minWidth: '160px', overflowLine: 1},
        {id: 'logName', header: '名称', field: 'slot:logName', minWidth: '200px', overflowLine: 1},
        {id: 'campaignName', header: '所属广告活动', field: 'campaignName', minWidth: '160px', overflowLine: 1},
        {id: 'groupName', header: '所属广告组', field: 'groupName', minWidth: '160px', overflowLine: 1},
        {id: 'objectType', header: '调整类型', field: 'slot:objectType', minWidth: '110px', overflowLine: 1},
        {id: 'operatingDetail', header: '调整记录', field: 'operatingDetail', minWidth: '185px', overflowLine: 1},
        {id: 'result', header: '操作结果', field: 'slot:result', minWidth: '90px', overflowLine: 1},
        {id: 'createUser', header: '操作人', field: 'createUser', minWidth: '90px', overflowLine: 1},
        {id: 'createDate', header: '操作时间（北京时间）', field: 'createDate', minWidth: '160px', overflowLine: 1},
      ],
      options: { // 枚举
        // 操作对象类型
        objectType: AdLog().objOptions,
        // 调整类型
        optOptions: AdLog().optOptions,
        // 操作结果
        resultOptions: AdLog().resultOptions,
      }
    }
  },
  methods:{
    async $gjQuery() {
      let params = {
        model:this.model,
        ...this.queryPagination,
        ...this.querySort
      };
      this.loading = true;
      this.globalParams = params;
      try {
        const { data } = await Log.operatingPage(params)
        this.tableData = (data.records || []);
        this.pagination = this.getPagination(data);
      } catch (error) {
        //
      } finally {
        this.loading = false
      }

    },
  }
}
</script>

<style scoped>

</style>